import { render, staticRenderFns } from "./EventTypeUpload.vue?vue&type=template&id=87b80682&scoped=true"
import script from "./EventTypeUpload.vue?vue&type=script&lang=js"
export * from "./EventTypeUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b80682",
  null
  
)

export default component.exports